var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 246,
    height: 254,
    viewBox: "0 0 246 254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car-circle",
    transform: "translate(-72 -304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_2",
    "data-name": "Ellisse 2",
    transform: "translate(75 308)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 120,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 119.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_3",
    "data-name": "Ellisse 3",
    transform: "translate(185 538)",
    fill: "rgba(255,255,255,0.3)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_4",
    "data-name": "Ellisse 4",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(191 544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_5",
    "data-name": "Ellisse 5",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(270 514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_6",
    "data-name": "Ellisse 6",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(112 514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_7",
    "data-name": "Ellisse 7",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(270 334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_8",
    "data-name": "Ellisse 8",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(112 334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_9",
    "data-name": "Ellisse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(310 424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_10",
    "data-name": "Ellisse 10",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(72 424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_11",
    "data-name": "Ellisse 11",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(191 304)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarCircle);
export default __webpack_public_path__ + "static/media/car-circle.8c245f94fb56d13874a0027278cb43ff.svg";
export { ForwardRef as ReactComponent };